module.exports = __webpack_public_path__ + "media/images/icons/marker-xx-ff91a645808c3e8daf815b4ba2e32d42.svg";